import { configureStore } from '@reduxjs/toolkit';
import { classActionMiddleware } from '@/store/_setup/classActionMiddleware';
import { listApi } from '@/api/listApi';

import { designerReducer } from '@/store/designer/designerReducer';
import { listReducer } from '@/store/lists/listReducer';
import { notificationsReducer } from '@/store/notifications/reducer/notificationsReducer';
import { userReducer } from '@/store/user/reducer/userReducer';

export const store = configureStore({
  reducer: {
    designer: designerReducer,
    user: userReducer,
    notifications: notificationsReducer,
    lists: listReducer,
    [listApi.reducerPath]: listApi.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(classActionMiddleware, listApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
